import React from 'react';
import { Badge } from 'react-bootstrap';
import '../../styles/status-badge.css';
import { RouteStates } from 'shared-pages/shared/constants';

interface BadgeProps {
  id: number;
  name: string;
}

/** Χρώμα κατάστασης δρομολογίου — `bg` του react-bootstrap (Bootstrap 5), όχι οι παλιές κλάσεις `badge-*` */
export const RouteStatusBadge = ({ id = 1, name = 'Μή Δρομολογημένη' }: BadgeProps) => {
  function colorVariant(id): string {
    return id === RouteStates.Planned
      ? 'primary'
      : id === RouteStates.Executed
      ? 'success'
      : 'dark';
  }

  return (
    <Badge pill={true} bg={colorVariant(id)} className="badge-status align-middle">
      {name}
    </Badge>
  );
};
